export default __webpack_public_path__ + "static/media/5e88081bcf416f10fd75a7eff82ced3d1581336258116.a21b6e3b.webp";